import { RPCErrorCode } from "./RPCErrorCode";

type RPCErrorStructure = {
    code?: number,
    message?: string,
    data?: {
        originalError?: {
            code?: number
        }
    }
};

export class RPCError {
    private readonly error: RPCErrorStructure;

    public get code(): RPCErrorCode {
        return this.error?.data?.originalError?.code ?? this.error?.code;
    }

    public get message(): string {
        return this.error?.message ?? "Unknow message of RPCError";
    }

    public constructor(error: unknown) {
        this.error = error as RPCErrorStructure;
    }
}